import {
  IconArchive,
  IconBug,
  IconCircleCheck,
  IconHelpCircle,
  IconInbox,
  IconList,
  IconMessageCircle,
  IconProgress,
} from '@tabler/icons-react';
import type { FilterPillDef } from '../components/filters/FilterPillGroup';
import {
  FILTER_PILL_DANGER,
  FILTER_PILL_INFO,
  FILTER_PILL_MUTED,
  FILTER_PILL_NEUTRAL,
  FILTER_PILL_SUCCESS,
  FILTER_PILL_WARNING,
} from '../lib/statusPillColors';

export const SUPPORT_TICKET_STATUS_FILTER_PILLS: readonly FilterPillDef[] = [
  { value: '', label: 'Tous', icon: IconList, ...FILTER_PILL_NEUTRAL },
  { value: 'OPEN', label: 'Ouvert', icon: IconInbox, ...FILTER_PILL_WARNING },
  { value: 'IN_PROGRESS', label: 'En cours', icon: IconProgress, ...FILTER_PILL_INFO },
  { value: 'RESOLVED', label: 'Résolu', icon: IconCircleCheck, ...FILTER_PILL_SUCCESS },
  { value: 'CLOSED', label: 'Fermé', icon: IconArchive, ...FILTER_PILL_MUTED },
];

export const SUPPORT_TICKET_TYPE_FILTER_PILLS: readonly FilterPillDef[] = [
  { value: '', label: 'Tous', icon: IconList, ...FILTER_PILL_NEUTRAL },
  { value: 'BUG', label: 'Bug', icon: IconBug, ...FILTER_PILL_DANGER },
  { value: 'QUESTION', label: 'Question', icon: IconHelpCircle, accent: '#7048e8', bg: 'color-mix(in srgb, #7048e8 12%, var(--wp-surface-card))', border: '#b197fc' }, // ponytail: no purple token
  {
    value: 'FEEDBACK',
    label: 'Retour',
    icon: IconMessageCircle,
    accent: '#0c8599', // ponytail: no cyan token
    bg: 'color-mix(in srgb, #0c8599 12%, var(--wp-surface-card))',
    border: '#99e9f2',
  },
];

/** Type pills only — matches support tickets table tags. */
export const SUPPORT_TICKET_TYPE_PILLS = SUPPORT_TICKET_TYPE_FILTER_PILLS.filter((pill) => pill.value !== '');
